export const localityReducer = (state = {}, action) => {
  switch (action.type) {
    // LIST OPERATIONS
    case "GET_LOCALITY_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        listLoading: true,
      };

    case "GET_LOCALITY_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        listLoading: false,
        localityList: action.payload,
        listError: null,
      };

    case "GET_LOCALITY_LIST_FAILED":
      return {
        ...state,
        loading: false,
        listLoading: false,
        listError: action.payload,
      };

    // SINGLE LOCALITY OPERATIONS
    case "GET_LOCALITY_REQUEST":
      return {
        ...state,
        loading: true,
        singleLoading: true,
      };

    case "GET_LOCALITY_SUCCESS":
      return {
        ...state,
        loading: false,
        singleLoading: false,
        locality: action.payload,
        singleError: null,
      };

    case "GET_LOCALITY_FAIL":
      return {
        ...state,
        loading: false,
        singleLoading: false,
        singleError: action.payload,
      };

    // ADD LOCALITY
    case "ADD_LOCALITY_REQUEST":
      return {
        ...state,
        loading: true,
        addLoading: true,
      };

    case "ADD_LOCALITY_SUCCESS":
      return {
        ...state,
        loading: false,
        addLoading: false,
        addError: null,
      };

    case "ADD_LOCALITY_FAILED":
      return {
        ...state,
        loading: false,
        addLoading: false,
        addError: action.payload,
      };

    // UPDATE LOCALITY
    case "UPDATE_LOCALITY_REQUEST":
      return {
        ...state,
        loading: true,
        updateLoading: true,
      };

    case "UPDATE_LOCALITY_SUCCESS":
      return {
        ...state,
        loading: false,
        updateLoading: false,
        updateError: null,
      };

    case "UPDATE_LOCALITY_FAILED":
      return {
        ...state,
        loading: false,
        updateLoading: false,
        updateError: action.payload,
      };

    // DELETE LOCALITY
    case "DELETE_LOCALITY_REQUEST":
      return {
        ...state,
        loading: true,
        deleteLoading: true,
      };

    case "DELETE_LOCALITY_SUCCESS":
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        deleteError: null,
      };

    case "DELETE_LOCALITY_FAILED":
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        deleteError: action.payload,
      };

    case "RESET_LOCALITY":
      return {
        ...state,
        locality: null,
        singleError: null,
        addError: null,
        updateError: null,
        deleteError: null,
        listError: null,
      };

    default:
      return state;
  }
};
